// Assign incremental delays per group, then reveal on entry
(function () {
  const groups = document.querySelectorAll('.bux-animate--reveal-group');

  groups.forEach(group => {
    const step  = Number(group.dataset.staggerStep  || 100); // ms between items
    const start = Number(group.dataset.staggerStart || 0);   // initial delay

    group.querySelectorAll('.bux-animate--reveal').forEach((el, i) => {
      el.style.setProperty('--stagger', `${start + i * step}ms`);
    });
  });

  const items = document.querySelectorAll('.bux-animate--reveal');

  if (!('IntersectionObserver' in window)) {
    items.forEach(el => el.classList.add('bux-animate--is-visible'));
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(({ isIntersecting, target }) => {
      if (isIntersecting) {
        target.classList.add('bux-animate--is-visible');
        io.unobserve(target); // animate once
      }
    });
  }, { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

  items.forEach(el => io.observe(el));
})();

